import {DashboardTileSize} from '../../../types/DashboardTileSize';
import {WorkshopOverviewDensity} from '../types/WorkshopOverviewDensity';

export const WORKSHOP_OVERVIEW_DENSITY_BY_SIZE: Record<DashboardTileSize, WorkshopOverviewDensity> =
  {
    quarter: 'compact',
    half: 'compact',
    tall: 'compact',
    wide: 'comfortable',
    large: 'comfortable',
  };
